module.exports = __webpack_public_path__ + "img/title2.af987407.png";